/*
 *
 * BlockedModal
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import BlockedModal from './BlockedModal'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(BlockedModal)
